export const configuration = {
  add: 'Dodaj nowy szablon konfiguracji',
  title: 'Szablony konfiguracji',
  noResults: 'Brak danych',
  newTitle: 'Tworzenie nowego szablonu konfiguracji produktu',
  newSubtitle:
    'Wybierz kryteria, których dotyczy szablon, a następnie nadaj mu nazwę.',
  progress: 'Postęp',
  criterionCounter: 'Kryterium {position} z {total}',
  required: 'Wymagane',
  optional: 'Opcjonalne',
  selectOneValue: 'Wybierz jedną wartość, aby kontynuować.',
  skipCriterionChoice: 'Pomiń ten krok',
  skipped: 'Pominięto',
  summary: 'Podsumowanie',
  summaryHint: 'Nazwa i ustawienia',
  summaryDescription: 'Sprawdź wybrane kryteria i nazwij szablon.',
  noCriteriaSelected: 'Nie wybrano żadnych kryteriów',
  startOver: 'Zacznij od nowa',
  createTemplate: 'Utwórz szablon',
  openEditor: 'Przejdź do edycji',
  newConfigurationName: 'Nazwa nowego szablonu konfiguracji',
  newNamePlaceholder: 'AE 86',
  configurationCreated: 'Konfiguracja została utworzona',
  configurationCreatedPara:
    'Przejść do ekranu modifykacji szablonu konfiguracji?',
  isDimmensionMode: 'Tryb wymiarów z modelu',
  modelFactorConversion: 'Przelicznik jednostek modelu',
  dimensionModeEnabledInfo:
    'Przełącznik włączony: długości są domyślne. Pole przelicznika jednostek modelu jest wtedy nieaktywne.',
  dimensionModeDisabledInfo:
    'Wyłączony: możesz ręcznie ustawić przelicznik jednostek modelu, który wpływa na długość sceny i obliczenia.',
  dimensionModeEditInfo:
    'Modyfikacja jednostki długości sceny i przelicznika jest dostępna tylko dla szkicu (draft) z uprawnieniem EDIT.',
  filters: {
    all: 'Wszystko',
    name: 'Wyszukaj',
    status: 'Status',
    createdBy: 'Autor',
    criterionValues: 'Kryteria',
  },
  errorCreatedConfiguration: 'Nie stworzono szablonu konfiguracji!',
}
